import { createFileRoute, useParams } from "@tanstack/react-router";
import { JobTypeAccessSection } from "./fullAccess";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/jobTypes/$jobTypeId/access",
)({
	component: OrgJobTypeAccessTab,
});

function OrgJobTypeAccessTab() {
	const { orgId } = useParams({
		from: "/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/jobTypes/$jobTypeId/access",
	});

	return (
		<div className="px-5 pb-5">
			<JobTypeAccessSection orgId={orgId} />
		</div>
	);
}
